module.exports = __webpack_public_path__ + "assets/img/mock-lawnmover-pic.d0e36f2e.png";